import React from "react";
import { AiFillLinkedin, AiOutlineGlobal, AiFillMail } from "react-icons/ai";
import HumanLogo from "../assets/LogoHuman.png";
import styles from "../styles/footer.module.css";

function Footer() {

  const signaxLogoClicked = () => {
    window.open("https://signa-x.io", "_blank");
  }

  const humanLogoClicked = () => {
    window.open("https://humanprotocol.org", "_blank");
  }

  return (
    <div className={styles["footer-container"]}>
      <div className={styles["footer-content"]}>
        <img
          src="https://asset-signax.b-cdn.net/Signa%20X%20Black.png"
          alt="signaxlogo"
          className={styles["image"]}
          onClick={()=>signaxLogoClicked()}
        />
        <div className={styles["socials"]}>
          <a href="https://www.linkedin.com/company/signa-x/" target="_blank">
            <AiFillLinkedin className={styles["icon"]} />
          </a>
          <a href="https://www.humanprotocol.org/"  target="_blank">
            <AiOutlineGlobal className={styles["icon"]} />
          </a>
          <a href="mailto:tech@signa-x.io"  target="_blank">
          <AiFillMail className={styles["icon"]} />
          </a>
          <p className={styles["copy"]}>© 2023</p>
        </div>
        <img src={HumanLogo} alt="signaxlogo" className={styles["image"]} onClick={()=>humanLogoClicked()}/>
      </div>
    </div>
  );
}

export default Footer;
